export default function isQr() {
  return window.jamezzApplicationType === "QR";
}
